import { render, staticRenderFns } from "./identificacion-peligros-editar.vue?vue&type=template&id=641557fe&scoped=true&"
import script from "./identificacion-peligros-editar.vue?vue&type=script&lang=js&"
export * from "./identificacion-peligros-editar.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-peligros-editar.vue?vue&type=style&index=0&id=641557fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641557fe",
  null
  
)

export default component.exports